<!-- Main Content: Cutter Map Visualization -->

<div class="row">
  <div class="col-lg-12">
    <ng-container>
      <div style="padding: .5rem .75rem;border-radius: 8px;background: #8b8b8b4f;border: dashed;">
        <div kendoTypography variant="p">
          <i>Note: Cutters that were assigned were marked as <span style="text-decoration: underline; font-weight: bold; color: #e05560;">OBS</span>, if you want to use these then you must change this RTA to a retrofit or request an override. </i>
        </div>
        <div *ngIf="obsAssignedFamilies$ | async as obsFamilies">
          <div *ngIf="obsFamilies.length" kendoTypography variant="p" style="margin-top: 4px;">
            <strong>OBS/D families in this design:</strong> {{ obsFamilies.join(', ') }}
          </div>
        </div>
      </div>
      <kendo-grid scrollable="none" style="margin-top: 10px; margin-bottom: 10px; width: 100%;"
        [rowClass]="getTableColor" [data]="cutterQuantities$ | async">
        <kendo-grid-column field="GroupNumber" title="#"
          [headerStyle]="{ 'background-color': '#333638', 'color': '#fef8f7', 'text-align': 'center', 'padding-top': '2px', 'padding-bottom': '2px', 'font-weight': 'bold', 'vertical-align': 'middle' }"
          [style]="{ 'padding': '0px', 'font-size': 'small', 'text-align': 'center' }"><ng-template
            kendoGridCellTemplate let-item let-rowIndex="rowIndex">
            <div [style.backgroundColor]="getCutterLineItemBackgroundColor(rowIndex + 1)" class="whole-cell">
              {{ item.index }}
            </div>
          </ng-template></kendo-grid-column>
        <kendo-grid-column field="SapNumber" title="Material #" media="md"
          [headerStyle]="{ 'background-color': '#333638', 'color': '#fef8f7', 'text-align': 'center', 'padding-top': '2px', 'padding-bottom': '2px', 'font-weight': 'bold', 'vertical-align': 'middle' }"
          [style]="{ 'padding-top': '1px', 'padding-bottom': '1px', 'font-size': 'small' }">
          <ng-template kendoGridCellTemplate let-item>
            {{ item.cutter.sapMaterialNumber}}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Name" title="Family" media="md"
          [headerStyle]="{ 'background-color': '#333638', 'color': '#fef8f7', 'text-align': 'center', 'padding-top': '2px', 'padding-bottom': '2px', 'font-weight': 'bold', 'vertical-align': 'middle' }"
          [style]="{ 'padding-top': '1px', 'padding-bottom': '1px', 'font-size': 'small' }">
          <ng-template kendoGridCellTemplate let-item>
            {{ item.cutter.name }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="Description" title="Description"
          [headerStyle]="{ 'background-color': '#333638', 'color': '#fef8f7', 'text-align': 'center', 'padding-top': '2px', 'padding-bottom': '2px', 'font-weight': 'bold', 'vertical-align': 'middle' }"
          [style]="{ 'padding-top': '1px', 'padding-bottom': '1px', 'font-size': 'small' }">
          <ng-template kendoGridCellTemplate let-item>
            {{ item.cutter.description }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="PDCType" title="Shape" media="md"
          [headerStyle]="{ 'background-color': '#333638', 'color': '#fef8f7', 'text-align': 'center', 'padding-top': '2px', 'padding-bottom': '2px', 'font-weight': 'bold', 'vertical-align': 'middle' }"
          [style]="{ 'padding-top': '1px', 'padding-bottom': '1px', 'font-size': 'small' }">
          <ng-template kendoGridCellTemplate let-item>
            {{ item.cutter.pdcType }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="LeachingDepth" title="Leach Depth" media="md"
          [headerStyle]="{ 'background-color': '#333638', 'color': '#fef8f7', 'text-align': 'center', 'padding-top': '2px', 'padding-bottom': '2px', 'font-weight': 'bold', 'vertical-align': 'middle' }"
          [style]="{ 'padding-top': '1px', 'padding-bottom': '1px', 'font-size': 'small' }">
          <ng-template kendoGridCellTemplate let-item>
            {{ item.cutter.leaching }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="qty" title="Qty"
          [headerStyle]="{ 'background-color': '#333638', 'color': '#fef8f7', 'text-align': 'center', 'padding-top': '2px', 'padding-bottom': '2px', 'font-weight': 'bold', 'vertical-align': 'middle' }"
          [style]="{ 'padding-top': '1px', 'padding-bottom': '1px', 'font-size': 'small' }"></kendo-grid-column>
      </kendo-grid>
    </ng-container>
  </div>

  <div class="col-lg-12">
    <kendo-splitter>
      <kendo-splitter-pane [collapsible]="true" size="250px">
        <form class="k-form k-form-md" [formGroup]="mappingTools">
          <kendo-panelbar>
            <kendo-panelbar-item title="Override" [disabled]="showOptions()">
              <ng-template kendoPanelBarContent>
                <div class="panel-content">
                  <form [formGroup]="overrideForm" (ngSubmit)="submitOverrideRequest()">
                    <kendo-label text="Cutter family">
                      <kendo-combobox [data]="overrideFamilies$ | async" textField="name" valueField="id"
                        [valuePrimitive]="true" formControlName="cutterFamily" placeholder="Select cutter family"
                        [size]="'small'">
                      </kendo-combobox>
                    </kendo-label>
                    <kendo-label class="k-display-block" text="Reason"></kendo-label>
                    <kendo-textarea formControlName="justification" [rows]="3"
                      placeholder="Explain why this family is needed, minimum of 5 characters"></kendo-textarea>
                    <kendo-label class="k-display-block" text="Your email (optional)"
                      style="margin-top: 6px;"></kendo-label>
                    <kendo-textbox formControlName="requesterEmail" placeholder="name@halliburton.com"></kendo-textbox>

                    <div style="margin-top: 10px;">
                      <button kendoButton themeColor="success" style="width: 100%; margin-bottom: 6px;"
                        [disabled]="overrideSubmitting || overrideForm.invalid">
                        {{ overrideSubmitting ? 'Submitting...' : 'Request override' }}
                      </button>
                    </div>
                    <kendo-formhint style="color:darkcyan;">Request the ability to place unavailable cutting
                      elements.</kendo-formhint>
                    <div *ngIf="overrideMessage" style="color: #008b4a; margin-top: 6px;">{{ overrideMessage }}</div>
                    <div *ngIf="overrideError" style="color: #842029; margin-top: 6px;">{{ overrideError }}</div>
                  </form>
                  <hr />
                  <form [formGroup]="overrideCodeForm">
                    <kendo-label class="k-display-block" text="Have an approval code?"></kendo-label>
                    <kendo-textbox formControlName="overrideCode" placeholder="Enter code">
                      <ng-template kendoTextBoxSuffixTemplate>
                        <button kendoButton fillMode="clear" themeColor="primary" [disabled]="overrideSubmitting"
                          (click)="applyOverrideCode()">
                          {{ overrideSubmitting ? 'Validating...' : 'Apply code' }}
                        </button>
                      </ng-template>
                    </kendo-textbox>
                  </form>
                </div>
              </ng-template>
            </kendo-panelbar-item>
            <!-- Primary / Backup -->
            <kendo-panelbar-item title="Primary" [disabled]="showOptions()">
              <ng-template kendoPanelBarContent>
                <div class="panel-content">
                  <div class="row">
                    <div class="col-md-12 col-lg-6">
                      <kendo-label text="Chamfer">
                        <kendo-combobox [data]="cutterChamfers$ | async" adaptiveMode="auto" [size]="'small'"
                          formControlName="PrimaryCutterChamfer">
                        </kendo-combobox>
                      </kendo-label>
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <kendo-label text="Family Type">
                        <kendo-combobox [data]="filteredPrimaryTypes$ | async" textField="Name" valueField="Name"
                          [valuePrimitive]="true" adaptiveMode="auto" [size]="'small'"
                          formControlName="PrimaryCutterType">
                        </kendo-combobox>
                      </kendo-label>
                    </div>
                    <div class="col-lg-12" style="margin-top: 10px;">
                      <button kendoButton themeColor="info" (click)="ChangeTypePrimary()"
                        style="width: 100%;">Apply</button>
                    </div>
                  </div>
                  <div *ngIf="primaryMessage" style="margin-top: 8px;">
                    <div kendoTypography variant="p" [style.color]="primaryDetails ? '#e63948' : '#008b4a'" style="margin: 0;">{{ primaryMessage }}</div>
                    <div *ngIf="primaryDetails" kendoTypography variant="p" style="margin: 0;">{{ primaryDetails }}</div>
                  </div>
                </div>
              </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item title="Secondary" [disabled]="showOptions()">
              <ng-template kendoPanelBarContent>
                <div class="panel-content">
                  <div class="row">
                    <div class="col-md-12 col-lg-6">
                      <kendo-label text="Chamfer">
                        <kendo-combobox [data]="cutterChamfers$ | async" (valueChange)="ChangeChamferSecondary($event)"
                          [size]="'small'" formControlName="SecondaryCutterChamfer" adaptiveMode="auto">
                        </kendo-combobox>
                      </kendo-label>
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <kendo-label text="Family Type">
                        <kendo-combobox [data]="filteredSecondaryTypes$ | async" textField="Name" valueField="Name"
                          [valuePrimitive]="true" [size]="'small'" formControlName="SecondaryCutterType"
                          adaptiveMode="auto">
                        </kendo-combobox>
                      </kendo-label>
                    </div>
                    <div class="col-lg-12" style="margin-top: 10px;">
                      <button kendoButton themeColor="info" (click)="ChangeTypeSecondary()"
                        style="width: 100%;">Apply</button>
                    </div>
                  </div>
                  <div *ngIf="secondaryMessage" style="margin-top: 8px;">
                    <div kendoTypography variant="p" [style.color]="secondaryDetails ? '#e63948' : '#008b4a'" style="margin: 0;">{{ secondaryMessage }}</div>
                    <div *ngIf="secondaryDetails" kendoTypography variant="p" style="margin: 0;">{{ secondaryDetails }}</div>
                  </div>
                </div>

              </ng-template>
            </kendo-panelbar-item>
            <!-- Global Apply -->
            <kendo-panelbar-item title="Place by Select" [disabled]="showOptions()">
              <ng-template kendoPanelBarContent>
                <div class="panel-content">
                  <div class="row">
                    <div class="col-lg-12">
                      <div style="width: 100%; text-align: center;">
                        <h6>Cutters</h6>
                      </div>
                      <hr style="margin: 0px !important;">
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <kendo-label text="Chamfer">
                        <kendo-combobox [data]="cutterChamfers$ | async" (valueChange)="ChangeChamferSecondary($event)"
                          adaptiveMode="auto" [size]="'small'" formControlName="PlaceCutterChamfer">
                        </kendo-combobox>
                      </kendo-label>
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <kendo-label text="Family Type">
                        <kendo-combobox [data]="filteredPlaceCutterTypes$ | async" textField="Name" valueField="Name"
                          [size]="'small'" adaptiveMode="auto" formControlName="PlaceCutterType">
                        </kendo-combobox>
                      </kendo-label>
                    </div>
                    <div class="col-lg-12">
                      <kendo-buttongroup width="100%" style="margin-top: 10px;">
                        <button kendoButton [toggleable]="true" title="Toggle Select Mode" (click)="ToggleAllowSelect()"
                          [size]="'small'">Select</button>
                        <button kendoButton themeColor="success" (click)="applyPlaceSelection()" [size]="'small'">Apply</button>
                      </kendo-buttongroup>
                    </div>
                  </div>
                  <div *ngIf="selectionMessage" style="margin-top: 8px;">
                    <div kendoTypography variant="p" style="color: #e63948; margin: 0;">{{ selectionMessage }}</div>
                    <div *ngIf="selectionDetails" kendoTypography variant="p" style="margin: 0;">{{ selectionDetails }}</div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <div style="width: 100%; text-align: center;">
                        <h6>Backup Elements</h6>
                      </div>
                      <hr style="margin: 0px !important;">
                    </div>
                    <div class="col-md-12 col-lg-12">
                      <kendo-label text="Family Type">
                        <kendo-dropdownlist
                          [data]="backupFamilies$ | async"
                          textField="Name"
                          valueField="Name"
                          formControlName="BackupFamilyType"
                          [size]="'small'">
                        </kendo-dropdownlist>
                      </kendo-label>
                    </div>
                    <div class="col-lg-12">
                      <kendo-buttongroup width="100%" style="margin-top: 10px;">
                        <button kendoButton [toggleable]="true" title="Toggle Select Mode" (click)="ToggleAllowSelect()"
                          [size]="'small'">Select</button>
                        <button kendoButton themeColor="success" (click)="ApplyGlobalBackups()"
                          [size]="'small'">Apply</button>
                      </kendo-buttongroup>
                    </div>
                  </div>
                </div>
              </ng-template>
            </kendo-panelbar-item>
            <!-- Element Groups -->
            <kendo-panelbar-item title="Element Groups" [disabled]="showOptions()">
              <ng-template kendoPanelBarContent>
                <div class="panel-content">
                  <div class="row">
                    <div class="col-lg-12">
                      <kendo-label text="Element">
                        <kendo-dropdownlist [data]="cutterGroups$ | async" textField="name" [valuePrimitive]="true"
                          formControlName="ElementType" [size]="'small'" valueField="name" adaptiveMode="auto"
                          (valueChange)="ChangeElementType($event)">
                        </kendo-dropdownlist>
                      </kendo-label>
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <kendo-label text="Chamfer">
                        <kendo-dropdownlist [data]="cutterChamfers$ | async" [valuePrimitive]="true"
                          (valueChange)="ChangeChamferSecondary($event)" formControlName="ElementChamfer"
                          [size]="'small'">
                        </kendo-dropdownlist>
                      </kendo-label>
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <kendo-label text="Family Type">
                        <kendo-dropdownlist [data]="filteredElementTypes$ | async" textField="Name" valueField="Name"
                          formControlName="ElementFamilyType" [valuePrimitive]="true" [size]="'small'">
                        </kendo-dropdownlist>
                      </kendo-label>
                    </div>
                    <div class="col-lg-12">
                      <kendo-buttongroup width="100%" style="margin-top: 10px;">
                        <button kendoButton [toggleable]="true" title="Toggle Select Mode" (click)="ToggleAllowSelect()"
                          [size]="'small'">Select</button>
                        <button kendoButton themeColor="success" (click)="ApplyGlobal()" [size]="'small'">Apply</button>
                      </kendo-buttongroup>
                    </div>
                  </div>
                  <div *ngIf="elementGroupMessage" style="margin-top: 8px;">
                    <div kendoTypography variant="p" [style.color]="elementGroupDetails ? '#e63948' : '#008b4a'" style="margin: 0;">{{ elementGroupMessage }}</div>
                    <div *ngIf="elementGroupDetails" kendoTypography variant="p" style="margin: 0;">{{ elementGroupDetails }}</div>
                  </div>
                </div>
              </ng-template>
            </kendo-panelbar-item>
            <!-- Zones -->
            <kendo-panelbar-item title="Zones" [disabled]="showOptions()">
              <ng-template kendoPanelBarContent>
                <div class="panel-content">
                  <div class="row">
                    <div class="col-md-12 col-lg-6">
                      <kendo-label text="Zone">
                        <kendo-dropdownlist [data]="zones" adaptiveMode="auto" [size]="'small'" textField="name"
                          valueField="name" formControlName="ZoneName">
                        </kendo-dropdownlist>
                      </kendo-label>
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <kendo-label text="Location">
                        <kendo-dropdownlist [data]="locations" adaptiveMode="auto" [size]="'small'" textField="name"
                          valueField="name" formControlName="ZoneLocation">
                        </kendo-dropdownlist>
                      </kendo-label>
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <kendo-label text="Chamfer">
                        <kendo-dropdownlist [data]="cutterChamfers$ | async" adaptiveMode="auto" [size]="'small'"
                          formControlName="ZoneChamfer">
                        </kendo-dropdownlist>
                      </kendo-label>
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <kendo-label text="Family Type">
                        <kendo-dropdownlist textField="Name" valueField="Name" adaptiveMode="auto" [size]="'small'"
                          [data]="filteredZoneTypes$ | async" [valuePrimitive]="true" formControlName="ZoneFamilyType">
                        </kendo-dropdownlist>
                      </kendo-label>
                    </div>
                    <div class="col-lg-12" style="margin-top: 10px;">
                      <button kendoButton themeColor="info" (click)="applyZonePlacement()"
                        style="width: 100%;">Apply</button>
                    </div>
                    <div class="col-lg-12" *ngIf="zoneMessage" style="margin-top: 8px;">
                      <div kendoTypography variant="p" [style.color]="zoneDetails ? '#e63948' : '#008b4a'" style="margin: 0;">{{ zoneMessage }}</div>
                      <div *ngIf="zoneDetails" kendoTypography variant="p" style="margin: 0;">{{ zoneDetails }}</div>
                    </div>
                  </div>
                </div>
              </ng-template>

            </kendo-panelbar-item>
            <!-- Pad Elements -->
            <kendo-panelbar-item title="Pad Elements" [disabled]="!isEJDF">
              <ng-template kendoPanelBarContent>
                <div class="panel-content">
                  <div class="row">
                    <div class="col-md-12 col-lg-6">
                      <kendo-label text="Element Type">
                        <kendo-combobox [data]="cutterChamfers$ | async" adaptiveMode="auto" [size]="'small'"
                          formControlName="PrimaryCutterChamfer">
                        </kendo-combobox>
                      </kendo-label>
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <kendo-label text="Family Type">
                        <kendo-combobox [data]="filteredPrimaryTypes$ | async" textField="Name" valueField="Name"
                          [valuePrimitive]="true" adaptiveMode="auto" [size]="'small'" 
                          formControlName="PrimaryCutterType">
                        </kendo-combobox>
                      </kendo-label>
                    </div>
                    <div class="col-lg-12" style="margin-top: 10px;">
                      <button kendoButton themeColor="info" (click)="ChangeTypePrimary()"
                        style="width: 100%;">Apply</button>
                    </div>
                  </div>
                </div>
              </ng-template>
            </kendo-panelbar-item>
          </kendo-panelbar>
          <div class="panel-content">
            <button kendoButton themeColor="warning" (click)="ClearCutterSelections()" [disabled]="showOptions()"
              style="width: 100%; margin-bottom: 10px;">Clear All Element Types</button>
            <button kendoButton themeColor="warning" (click)="ClearSelectedElements()" style="width: 100%; margin-bottom: 10px;">Clear
              Selected Elements</button>
            <button kendoButton themeColor="info" (click)="downloadMappedFile()" style="width: 100%;">Download Mapped File</button>
          </div>
        </form>
      </kendo-splitter-pane>

      <kendo-splitter-pane>
        <form [formGroup]="appcutterMappingData">
          <div class="blade-section">
            <ng-container *ngIf="blades?.length; else emptyBladeState">

              <!-- ARM-grouped view -->
              <ng-container *ngIf="hasArmNumbers; else flatBladeList">
                <div *ngFor="let arm of arms" class="arm-group">
                  <div class="arm-header">
                    <span class="arm-badge">ARM {{ arm }}</span>
                  </div>
                  <div class="blade-list">
                    <ng-container *ngTemplateOutlet="bladeCards; context: { blades: getBladesForArm(arm) }"></ng-container>
                  </div>
                </div>
              </ng-container>

              <!-- Flat (no-arm) view -->
              <ng-template #flatBladeList>
                <div class="blade-list">
                  <ng-container *ngTemplateOutlet="bladeCards; context: { blades: blades }"></ng-container>
                </div>
              </ng-template>

            </ng-container>
          </div>

          <!-- Shared blade card template -->
          <ng-template #bladeCards let-bladeList="blades">
            <article class="blade-card" *ngFor="let bladeNo of bladeList">
              <div class="blade-title">
                <span class="blade-badge">BLADE-{{ bladeNo }}</span>
              </div>
              <div class="row-list">
                <div class="row-line" *ngFor="let rowNo of getUniqueRows(bladeNo); let a = index;">
                  <div kendoTypography variant="h4" style="color: whitesmoke;">R{{ a + 1 }}</div>

                  <div class="cutter-line">
                    <div class="cutter-chip" *ngFor="let cutter of getFilteredRows(bladeNo, rowNo)">
                      <div class="avatar-with-text"
                        [ngClass]="{ selected: isCutterSelected(cutter), highlight: isCutterHighlighted(cutter) }">
                        <kendo-badge-container *ngIf="rowNo==1; else trailingRow">
                          <kendo-avatar [initials]="cutter.facePosition??''" rounded="full"
                            [ngStyle]="{'background-color': getColorByPdcCutterId(cutter.pdcCutter_Id)}"
                            [size]="'medium'" (click)="ToggleSelect(cutter)"
                            [title]="getShapeNameById(cutter?.shape_Id)">
                            <kendo-badge size="small" themeColor="primary" [cutoutBorder]="true"
                              [ngClass]="rowNo==1?'LeadingRow': 'TrailingRow'"
                              style="font-size: 12px; font-weight: bold;">{{cutter.numberOnRow}}
                            </kendo-badge>
                          </kendo-avatar>
                        </kendo-badge-container>
                        <div class="avatar-caption" *ngIf="cutter?.zone" [ngClass]="cutter.zone">{{cutter.zone}}</div>
                      </div>

                      <ng-template #trailingRow>
                        <kendo-avatar [initials]="cutter.facePosition??''"
                          [ngStyle]="{'background-color': getColorByPdcCutterId(cutter.pdcCutter_Id)}"
                          [size]="'medium'" (click)="ToggleSelect(cutter)"
                          [title]="getShapeNameById(cutter?.shape_Id)">
                        </kendo-avatar>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </ng-template>

        </form>
        <ng-template #emptyBladeState>
          <div class="blade-empty">
            <span class="k-icon k-font-icon k-i-information"></span>
            <p>No blades have been generated for this cutter map.</p>
          </div>
        </ng-template>
      </kendo-splitter-pane>
    </kendo-splitter>
  </div>

</div>

<kendo-popover #addMultiCutters position="right">
  <ng-template kendoPopoverBodyTemplate>
    <kendo-textbox placeholder="Cutter amount" title="Append set amount of cutter to end of row"
      [(ngModel)]="multiCutterAdd">
      <ng-template kendoTextBoxSuffixTemplate>
        <button kendoButton fillMode="clear" [svgIcon]="svgPlus" title="Append set amount of cutter to end of row"
          (click)="appendCutters()"></button>
      </ng-template>
    </kendo-textbox>
  </ng-template>
</kendo-popover>
<!-- No RTA Data warning -->
<div *ngIf="false" class="text-center mt-5">
  <h4>You must run the RTA Data Generator within IBitS before you can define a cutter map.</h4>
  <img src="public\assets\images\rta_data_generator.gif" alt="Run RTA Data Generator" />
</div>
